/* lib/telegramLink.js — контракт статусов привязки Telegram через бота.
 *
 * Статусы зеркалят backend (accounts.models.TelegramLinkRequest.STATUS_CHOICES +
 * `unknown` из consume_link_request) байт-в-байт. Фронт делит их на три исхода:
 * pending (ждём Start в боте), done (привязано — закрыть модалку, обновить юзера),
 * failed (показать причину и предложить новую ссылку). Незнакомый статус — failed
 * с общим текстом, а не вечный спиннер. */

export const LINK_POLL_INTERVAL_MS = 2000;

export const LINK_DONE_STATUSES = ['linked', 'merged', 'already'];
export const LINK_FAILED_STATUSES = ['telegram_in_use', 'target_has_telegram', 'expired', 'unknown'];

const FAILURE_TEXT = {
  telegram_in_use: 'Этот Telegram уже привязан к другому аккаунту Ресториум. Сначала отвяжите его там.',
  target_has_telegram: 'К вашему аккаунту уже привязан другой Telegram — отвяжите его и попробуйте снова.',
  expired: 'Ссылка устарела или уже использована. Запросите новую — она действует 15 минут.',
  unknown: 'Ссылка не распознана. Запросите новую и откройте бота именно по ней.',
};

/** 'pending' | 'done' | 'failed' */
export function linkOutcome(status) {
  if (status === 'pending') return 'pending';
  if (LINK_DONE_STATUSES.includes(status)) return 'done';
  return 'failed';
}

export function linkFailureText(status) {
  return FAILURE_TEXT[status] || 'Не удалось привязать Telegram. Запросите новую ссылку и попробуйте снова.';
}
